import {Component, OnInit, OnDestroy, Input} from "@angular/core";
import {Observable, Subject} from "rxjs";
import "rxjs/add/observable/interval";
import "rxjs/add/operator/takeUntil";
import {Names} from "../names";
import {AuthorizationService} from "../Authorization/AuthorizationService";
import {UserService} from "../Authorization/UserService";
import {BrandingService} from "../Branding/BrandingService";
import {AppNavigationService} from "../Extranet/AppNavigationService";
import {FreshdeskWidgetService} from "./FreshdeskWidgetService";
import {MomentPipe} from "../CustomPipes/MomentPipe";
import {Router} from "@angular/router";
import * as moment from "moment";

@Component({
    selector: Names.applicationBar.selector,
    template: require("./applicationBar.html")
})
export class ApplicationBarComponent implements OnInit, OnDestroy {
    @Input("show-username") showUsername = true;
    @Input("show-time") showTime = true;

    serviceName: string;
    showHelp: boolean;
    username: string;
    time: string;
    timeZone: string;
    initilizeNavbar: boolean;
    private timeZoneIdentifier: string = "Europe/Oslo";

    private $destroy: Subject<boolean> = new Subject<boolean>()

    constructor(private authorizationService: AuthorizationService,
                private userService: UserService,
                private appNavigationService: AppNavigationService,
                private brandingService: BrandingService,
                private freshdeskWidgetService: FreshdeskWidgetService,
                private router: Router) {
    }

    ngOnInit() {
        this.initilizeNavbar = true;
        this.userService.getUserSubject().subscribe((user) => {
            if(!user)
                return;

            if(this.initilizeNavbar) {
                this.appNavigationService.initialise();
                this.initilizeNavbar = false;
            }
            this.freshdeskWidgetService.init();
        
            this.serviceName = this.brandingService.getSystemConfiguration().ServiceName;
            this.showHelp = this.brandingService.getSystemConfiguration().FreshdeskWidgetEnabled;
            this.username = this.userService.user.username;
        });

        if (this.showTime) {
            Observable
                .interval(1000)
                .takeUntil(this.$destroy)
                .subscribe(x => this.updateTime());
            this.updateTime();
        }
    }

    ngOnDestroy(): void {
        this.$destroy.next(true);
        this.$destroy.unsubscribe();
    }

    help() {
        this.freshdeskWidgetService.show();
    }

    logout() {
        this.authorizationService.logout();
    }

    private updateTime(): void {
        const currentTime = (moment() as any).tz(this.timeZoneIdentifier);

        this.time = MomentPipe.staticTransform(currentTime, "HH:mm");
        this.timeZone = currentTime.format("z");
    }

    private navigateToHomePage() {
        this.router.navigate(["/"]);
    }
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/ApplicationBar/ApplicationBarComponent.ts